import React from 'react';
import RHFLegacyField from '#component/form/rhf/rhf-legacy-field';
import { CustomFieldValue } from './styles';
import CustomFieldItemActions from './custom-field-item-actions';

const CustomFieldItem = props => {
  const {
    index,
    member,
    remove,
    forceError,
    placeholder
  } = props;

  const deleteCustomFieldItem = event => {
    event.stopPropagation();
    remove(index);
  };

  return (
    <>
      <RHFLegacyField
        name={`${member}.customFieldValue`}
        component={CustomFieldValue}
        placeholder={placeholder}
        variant="outlined"
        forceError={forceError}
        label="Field value"
      />
      <CustomFieldItemActions
        deleteCustomFieldItem={deleteCustomFieldItem}
        tooltipTitle="Delete custom field value"
      />
    </>
  );
};

export default CustomFieldItem;
